import type { MemberGender } from '@bm/contracts';

/** Geschlechter-Hintergrund — leichtes Blau (männlich) / Rosa (weiblich),
 * konsistent über die ganze App verwendet (Mannschaftsaufstellung,
 * Verlegungsassistent). Kein gesetztes Geschlecht bleibt neutral. */
export function genderBgClass(gender: MemberGender | null): string {
  if (gender === 'm') return 'border-blue-100 bg-blue-50';
  if (gender === 'w') return 'border-pink-100 bg-pink-50';
  return 'border-slate-200 bg-white';
}

/** Textfarbe passend zu `genderBgClass`, für Chips ohne eigenen Rahmen. */
export function genderTextClass(gender: MemberGender | null): string {
  if (gender === 'm') return 'text-blue-700';
  if (gender === 'w') return 'text-pink-700';
  return 'text-slate-600';
}
